__turbopack_context__.v({
  "btn": "shell-module__IrFHRq__btn",
  "btnBrand": "shell-module__IrFHRq__btnBrand",
  "btnFull": "shell-module__IrFHRq__btnFull",
  "btnSmall": "shell-module__IrFHRq__btnSmall",
  "btnTonal": "shell-module__IrFHRq__btnTonal",
  "contact": "shell-module__IrFHRq__contact",
  "dateText": "shell-module__IrFHRq__dateText",
  "dateWell": "shell-module__IrFHRq__dateWell",
  "footer": "shell-module__IrFHRq__footer",
  "header": "shell-module__IrFHRq__header",
  "link": "shell-module__IrFHRq__link",
  "long": "shell-module__IrFHRq__long",
  "mark": "shell-module__IrFHRq__mark",
  "markChip": "shell-module__IrFHRq__markChip",
  "markLogo": "shell-module__IrFHRq__markLogo",
  "markName": "shell-module__IrFHRq__markName",
  "monogram": "shell-module__IrFHRq__monogram",
  "num": "shell-module__IrFHRq__num",
  "page": "shell-module__IrFHRq__page",
  "pill": "shell-module__IrFHRq__pill",
  "shell": "shell-module__IrFHRq__shell",
  "short": "shell-module__IrFHRq__short",
  "topBar": "shell-module__IrFHRq__topBar",
});
